import { render, staticRenderFns } from "./LicenciaAlcoholesCarga.vue?vue&type=template&id=73980b2c&"
import script from "./LicenciaAlcoholesCarga.vue?vue&type=script&lang=js&"
export * from "./LicenciaAlcoholesCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports